import curry from "../../../../lib/core/functional/curry";

function setElementAttributeOnEvent(element, attribute, value, event) {
    element[attribute] = value;
}

export const setElementAttribute = curry(setElementAttributeOnEvent);

function toggleClassOnNonMatch(className, selector, element) {
    if (element.matches(selector)) {
        element.classList.remove(className);
    } else {
        element.classList.add(className);
    }
}

const toggleElementClass = curry(toggleClassOnNonMatch);

function toggleSiblings(element, selector, scrollTo, event) {
    Array.from(element.parentNode.children).forEach(toggleElementClass("hidden", selector));
    const visibleSibling = element.parentNode.querySelector(selector);
    if (visibleSibling && scrollTo) visibleSibling.scrollIntoView({ behavior: "smooth" });
    event.preventDefault();
}

export const toggleSiblingsOf = curry(toggleSiblings);

function findError(errors) {
    if (!errors || typeof errors !== "object" || Object.keys(errors).length === 0) {
        return null;
    }

    return Object.values(errors)
        .flatMap((e) => e)
        .join(" ");
}

function displayEvent(container, event) {
    container.classList.remove("hidden");
    container.textContent =
        event.detail.message || event.detail.error || findError(event.detail.errors);
}

export const displayEventOnElement = curry(displayEvent);

function wipeContainter(container) {
    container.classList.add("hidden");
    container.textContent = "";
}

export function cleanElements(...containers) {
    return function _cleanElements() {
        containers.forEach(wipeContainter);
    };
}

function elementValueReducer(store, element) {
    store[element.name] = element.type === "checkbox" ? element.checked : element.value;
    return store;
}

function addValuesToStore(namespace, element, store) {
    let storeAcum = store;

    if (namespace) {
        if (!(namespace in store)) store[namespace] = {};
        storeAcum = store[namespace];
    }

    Array.from(element.querySelectorAll("input,select")).reduce(elementValueReducer, storeAcum);

    return store;
}

export const getValuesFromModule = curry(addValuesToStore);
